module.exports = __webpack_public_path__ + "img/1.82dd7541.jpg";